import { Avatar, Button, VStack } from "@chakra-ui/react";
import React, {
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  forwardRef,
} from "react";

const MentionList = forwardRef((props, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const containerRef = useRef(null);

  const selectItem = (index) => {
    const item = props.items[index];
    console.log("selecting item", item);

    if (item) {
      if (item.type === "user") {
        // Handle user mention - this will create a userMention node
        props.command({
          id: item.id,
          label: item.name,
          type: "user",
        });
      } else if (item.type === "section") {
        // Handle section link - this will create a sectionMention node
        props.command({
          id: item.id,
          label: item.name,
          type: "section",
          section: item.section,
        });
      }
    }
  };

  const upHandler = () => {
    setSelectedIndex(
      (selectedIndex + props.items.length - 1) % props.items.length,
    );
  };

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };

  const enterHandler = () => {
    selectItem(selectedIndex);
  };

  useEffect(() => setSelectedIndex(0), [props.items]);

  useEffect(() => {
    if (selectedIndex >= 0 && containerRef.current) {
      const selectedElement = containerRef.current.children[selectedIndex];
      if (selectedElement) {
        selectedElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }
  }, [selectedIndex]);

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === "ArrowUp") {
        upHandler();
        return true;
      }

      if (event.key === "ArrowDown") {
        downHandler();
        return true;
      }

      if (event.key === "Enter") {
        enterHandler();
        return true;
      }

      return false;
    },
  }));
  return (
    <VStack
      ref={containerRef}
      spacing={0}
      align="stretch"
      w="100%"
      bg="white"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="md"
      boxShadow="lg"
      maxH="200px"
      overflowY="auto">
      {props.items.length ? (
        props.items.map((item, index) => (
          <Button
            border={0}
            gap="0.25rem"
            display="flex"
            width="full"
            variant="unstyled"
            px={4}
            py={2}
            minH={8}
            borderRadius={0}
            justifyContent="flex-start"
            fontSize="sm"
            fontWeight="normal"
            color="gray.900"
            bg={index === selectedIndex ? "gray.100" : "transparent"}
            _hover={{ bg: "gray.100" }}
            _focus={{ bg: "gray.100", outline: "none" }}
            _first={{ borderTopRadius: "md" }}
            _last={{ borderBottomRadius: "md" }}
            transition="background-color 0.2s"
            key={index}
            onClick={() => selectItem(index)}
            leftIcon={
              item.type === "user" ? (
                <Avatar size="xs" name={item.name} />
              ) : undefined
            }>
            {item.name}
          </Button>
        ))
      ) : (
        <Button
          border={0}
          gap="0.25rem"
          display="flex"
          width="100%"
          variant="unstyled"
          px={4}
          py={2}
          minH={8}
          borderRadius={0}
          justifyContent="flex-start"
          fontSize="sm"
          fontWeight="normal"
          color="gray.900"
          _hover={{ bg: "gray.100" }}
          _focus={{ bg: "gray.100", outline: "none" }}
          _first={{ borderTopRadius: "md" }}
          _last={{ borderBottomRadius: "md" }}
          transition="background-color 0.2s">
          No result
        </Button>
      )}
    </VStack>
  );
});

export default MentionList;
